import { useState, useEffect } from 'react';
import { toAbsoluteUrl } from '../../_vtsl/helpers';
import Data from '../utils/SetGetData';

// Custom event for profile picture updates
const PROFILE_PIC_UPDATE_EVENT = 'profilePicUpdated';

export const useProfilePic = () => {
  const [profilePic, setProfilePic] = useState(null);

  // Get profile picture from local storage
  const refreshProfilePic = async () => {
    const storedProfilePic = await Data.getData('profile_pic');
    setProfilePic(storedProfilePic);
  };

  useEffect(() => {
    refreshProfilePic();

    // Listen for profile picture updates from other components
    const handleProfilePicUpdate = () => {
      refreshProfilePic();
    };

    window.addEventListener(PROFILE_PIC_UPDATE_EVENT, handleProfilePicUpdate);

    return () => {
      window.removeEventListener(PROFILE_PIC_UPDATE_EVENT, handleProfilePicUpdate);
    };
  }, []);

  // Construct the profile picture URL using the API
  const getProfilePicUrl = () => {
    if (profilePic) {
      return `${process.env.REACT_APP_API_URL}${profilePic}`;
    }
    // Fallback to the original static image
    return toAbsoluteUrl('/media/avatars/300-1.jpg');
  };

  // Function to notify other components about profile picture updates
  const notifyProfilePicUpdate = () => {
    window.dispatchEvent(new Event(PROFILE_PIC_UPDATE_EVENT));
  };

  return { profilePic, getProfilePicUrl, setProfilePic, refreshProfilePic, notifyProfilePicUpdate };
}; 